import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#5C5C5C",
  d: "M2.322 14c-.416 0-.77-.146-1.062-.438A1.444 1.444 0 0 1 .822 12.5v-11c0-.417.146-.77.438-1.062A1.444 1.444 0 0 1 2.322 0h5.5v1.5h-5.5v11h11V7h1.5v5.5c0 .417-.146.77-.438 1.062a1.444 1.444 0 0 1-1.062.438h-11Zm3.562-4L4.822 8.938 12.26 1.5H9.822V0h5v5h-1.5V2.562L5.884 10Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };